module.exports = __webpack_public_path__ + "img/image4.f2590601.png";